import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { useBaseHistory } from 'spindl-shared-components';

import { DatabaseBlockCombinedProps } from './types';
import { formatDate, getUnderline } from '../../../lib/utils';
import { getDatabasesUseCase } from './DatabaseBlock.interactor';

const usePresenter = (props: DatabaseBlockCombinedProps): DatabaseBlockCombinedProps => {
  const { data: databases, isLoading } = useQuery('getDatabases', getDatabasesUseCase);
  const { t } = useTranslation();
  const history = useBaseHistory();

  const routeToDatabasePage = (slug: string) => {
    history.push(`/database/${slug}`);
  };

  if (!databases?.length && !isLoading) {
    return {
      ...props,
      state: 'Empty',
      title: {
        value: t('database_home_page.messages.no_databases'),
      },
      instructions: {
        value: t('database_home_page.messages.speak_to_rti_rep'),
      },
    };
  }

  return {
    ...props,
    state: isLoading ? 'Loading' : 'Default',
    itemCardList: {
      itemCards: databases?.map((database, index) => {
        const formattedDate = formatDate(database.updatedAt);
        return {
          labelText: {
            value: database?.name,
          },
          underline: {
            styleType: getUnderline(index),
          },
          icon: {
            asset: 'Calendar',
          },
          dateText: {
            value: `${t(
              'database_home_page.database_card.last_modified',
            )} ${formattedDate}`,
          },
          onClick: () => routeToDatabasePage(database.slug),
        };
      }),
    },
  };
};

export default usePresenter;
